// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-2953943e] {\n  margin-left: 2rem;\n}", ""]);
// Exports
module.exports = exports;
